wbApp.controller('SubjectsDetailCtrl', ['$scope', 'subjectsSvc', 'tenantInfo', 'tenantSettingSvc',
function ($scope, subjectsSvc, tenantInfo, tenantSettingSvc) {

    $scope.enableNewClientDesign = tenantSettingSvc.settings.enableNewClientDesign;
    
    $scope.modelOrig = angular.copy($scope.model);

    
    $scope.isFranchiseSubject = function () {
        return (!!$scope.model.franchiseSubjectID || !!$scope.model.franchiseCentralTenantID) && !tenantInfo.isFranchiseCentral;
    }

    $scope.isAnyFranchiesActive = !!_.find(tenantInfo.franchiseCentrals, { isActive: true, supportSubjectLicenses: true });

    $scope.isFranchiseCentral = tenantInfo.isFranchiseCentral;

    $scope.isFranchiesActive = function () {
        return !!_.find(tenantInfo.franchiseCentrals, { tenantID: $scope.model.franchiseCentralTenantID, isActive: true });
    }

    $scope.detailIsUnchanged = function (data) {
        return angular.equals(data, $scope.modelOrig);
    };

    $scope.onSubjectDetailSave = function (data) {

        if ($scope.isSaving) {
            return;
        }

        $scope.isSaving = true;

        if (!data.id) {
            subjectsSvc.insert(data, success, error);
        } else {
            subjectsSvc.update(data, success, error);
        }

        function success() {
            $scope.$hide();
        }

        function error(data) {
            $scope.detailError = data;
            $scope.isSaving = false;
        }
    }

    $scope.onFranchiseCentralChange = function (franchiseCentralID) {
        if (!franchiseCentralID) {
            $scope.model.franchiseCentralTenantID = null;
            $scope.model.franchiseSubjectID = null;
        }
    }

    $scope.onFranchiseSubjectChange = function (franchiseSubjectID) {
        if (franchiseSubjectID) {
            subjectsSvc.getFranchiseCentralSubject(
                $scope.model.franchiseCentralTenantID,
                franchiseSubjectID)
            .then(function (subject) {
                if (subject) {
                    $scope.model.name = subject.name;
                    $scope.model.description = subject.description;
                } else {
                    $scope.model.name = '';
                    $scope.model.description = null;
                }
            });
        } else {
            $scope.model.name = '';
            $scope.model.description = null;
        }
    }

}]);
